import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabs-panel',
  templateUrl: './tabs-panel.component.html',
  styleUrls: ['./tabs-panel.component.css']
})
export class TabsPanelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void{
  }

}
